<template>
    <li class="form-fields-companies-list flex-row jc-space py-3 px-2 ai-center fs-3 lh-20" :class="{'cpointer': enabled}" @click="selectCompany(company)" >
        <div class="flex-row ai-center">
            <div class="form-fields-companies-list--icon mr-2">
                <icon-svg :icon-name="third" :width="32" :height="32" viewBox="0 0 32 32">
                    <component :is="`icon-${third}`"></component>
                </icon-svg>
            </div>
            <div class="flex-column lh-20" :class="{'pl-2': (allowRemove && !overview)}">
                <div class="form-fields-companies-list--company-name">
                    <strong v-if="third === 'individual'">{{ civility }} {{ company.name }} {{ company.forename }}</strong>
                    <strong v-else>{{ company.name | upperCase }}</strong>
                    <badge v-if="allowBadge" dot inline tooltip :badges="badge(company)" />
                </div>
                <span class="gray-60 ellipsis wp-10 max-size-item" v-if="allowRemove && !overview">
                    {{ postalCode }}
                    {{ city | upperCase }}
                </span>
            </div>
        </div>
        <span class="gray-60 aleft no-wrap" v-if="!allowRemove && !overview">
            {{ postalCode }}
            {{ city | upperCase }}
        </span>
        <div v-if="overview || allowEdit || allowRemove" class="flex-row jc-space">
            <a v-if="allowEdit" href="javascript:;" @click="$emit('edit-company', company)" class="aright fs-3 hover-primary-100 semibold nowrap self-center" :data-bot="getDatabot('edit', dataBotsContext, null, 'company')">{{ $l10n.__("Modifier") }}</a>
            <a v-if="allowRemove" href="javascript:;" @click="$emit('remove-company')" class="aright fs-3 hover-primary-100 semibold nowrap self-center" :data-bot="getDatabot('cancel', dataBotsContext, null, 'company')">{{ $l10n.__("Annuler") }}</a>
            <router-link v-if="overview" :to="routerLinkParams()" target="_blank" class="aright fs-3 ml-3 hover-primary-100 semibold nowrap self-center cpointer hover-primary-100" >{{ toOverViewLabel }}</router-link>
        </div>
    </li>
</template>

<script>
    import TagHumansConfig from 'Config/authenticated/TagHumans';
    import CivilitiesConfig from "Config/authenticated/Civilities";
    import IconSvg from 'vcomponents/icons/IconSvg.vue';
    import IconCompany from 'vcomponents/icons/IconCompany.vue';
    import IconIndividual from 'vcomponents/icons/IconIndividual.vue';
    import Badge from 'vcomponents/utilities/Badge.vue';
    import DataBotsFormsMixins from "mixins/DataBotsFormsMixins";

    export default {
        mixins: [DataBotsFormsMixins],
        props:{
            company: {
                type: Object,
                required: true
            },
            enabled: {
                type: Boolean,
                required: false,
                default:false
            },
            allowEdit: {
                type: Boolean,
                required: false,
                default:false
            },
            allowBadge: {
                type: Boolean,
                required: false,
                default:false
            },
            allowRemove: {
                type: Boolean,
                required: false,
                default:false
            },
            displaySiret: {
                type: Boolean,
                required: false,
                default:false
            },
            overview:{
                type: Boolean,
                required: false,
                default: false
            },
            overviewWording:{
                type : String,
                required: false,
            },
            third:{
                type: String,
                required: false,
                default: "company"
            },
            dataBotsContext: {
                type: String,
                required: false,
                default : ''
            }
        },
        components:{
            IconSvg,
            IconIndividual,
            IconCompany,
            Badge,
        },
        data(){
            return {
                civilities : CivilitiesConfig
            }
        },
        computed:{
            toOverViewLabel(){
                return (this.overviewWording ? this.overviewWording : this.$l10n.__("Voir la fiche") )
            },
            postalCode(){
                return (this.company.address?.postal_code || null)
            },
            city(){
                return (this.overview && this.company.invoicing_address) ? this.company.invoicing_address : this.company.address?.city;
            },
            type(){
                return this.company.type;
            },
            civility(){
                let currentCivility = "";
                let thirdCivility = "";
                if(typeof this.company.civility === "string" ){
                    thirdCivility = this.company.civility;
                }else if(typeof this.company.civility?.value === "string"){
                    thirdCivility = this.company.civility.value;
                }
                if(thirdCivility && !_.isEmpty(thirdCivility)){
                    for(let i = 0; i < this.civilities.length; i++){
                        if(this.civilities[i].value === thirdCivility){
                            currentCivility = this.civilities[i].label;
                            break;
                        }
                    }
                }
                return currentCivility;
            }

        },
        methods:{
            badge(company) {
                let type = (this.overview ? company.object.sub_type : company.type);
                let typeTag = Object.entries(TagHumansConfig).find(tag => tag[0] === type)
                return  (!_.isNil(typeTag) ? [{...typeTag[1]}] : {});
            },

            selectCompany(company){
                this.$emit("select-company", company)
            },
            routerLinkParams(){
                return {name: "third.overview.informations", params: { type: this.company.object.sub_type, id: this.company.object.id }}
            }
        }
    }
</script>
<style scoped lang="scss">
    .form-fields-companies-list--icon{
        width: 32px;
        height: 32px;
    }
    .form-fields-companies-list--company-name{
        max-width: 305px;
        overflow: hidden;
    }
    .no-pointer-event{
        pointer-events: none;
    }
    .max-size-item{
        max-width: 320px;
    }
    .no-wrap{
        white-space: nowrap;
    }
    .info-item{
        max-width: 592px !important;
    }
    .info-overview {
        justify-content: space-between;
        max-width: 512px;
    }
    li:last-child{
        margin-bottom: 0 !important;
    }
    li a:last-child{
        margin-left: 24px !important;
        align-self: center;
    }
</style>
